export default "__VITE_ASSET__e3d6cc96__"